import React from 'react'
import CircularProgress from '@material-ui/core/CircularProgress';
import styles from './progress.module.css'
import { makeStyles } from '@material-ui/core/styles'

const useStyles = makeStyles((theme) => ({
    colorPrimary: {
        color: "#073748"
    }
}))
export default function Progress(props) {
    const classes = useStyles()
    return (
        <div className={props.css}>
            <CircularProgress className={classes.colorPrimary} disableShrink />
        </div>
    )
}